import { render } from "./ContainerChat.vue?vue&type=template&id=5d9863ca"
import script from "./ContainerChat.vue?vue&type=script&lang=js"
export * from "./ContainerChat.vue?vue&type=script&lang=js"

import "./ContainerChat.vue?vue&type=style&index=0&id=5d9863ca&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__